import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceLibrary {
    lookupService = new APIServiceLookUp();

    async getAllLibrary(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/getAllLibrary`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async getAllLibrarySection(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/getAllLibrarySection`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setLibrary(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/setLibrary`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateLibrary(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/updateLibrary`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateLibrarySection(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/updateLibrarySection`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delLibrary(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}library/delLibrary`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

}
